import { render, staticRenderFns } from "./li-dialog.vue?vue&type=template&id=4c2e9f07&scoped=true"
import script from "./li-dialog.vue?vue&type=script&lang=js"
export * from "./li-dialog.vue?vue&type=script&lang=js"
import style0 from "./li-dialog.vue?vue&type=style&index=0&id=4c2e9f07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2e9f07",
  null
  
)

export default component.exports